<template>
    <ul class="app-pager" @click="onPagerClick" @keyup.enter="onPagerClick">
        <li
            v-if="pageCount > 0"
            :class="{ active: currentPage === 1 }"
            tabindex="0"
            class="number">
            1
        </li>
        <li
            v-if="showPrevMore"
            :class="[quickprevIconClass]"
            class="app-icon more btn-quickprev"
            tabindex="0" />
        <li
            v-for="pager in pagers"
            :key="pager"
            :class="{ active: currentPage === pager }"
            tabindex="0"
            class="number">
            {{ pager }}
        </li>
        <li
            v-if="showNextMore"
            :class="[quicknextIconClass]"
            class="app-icon more btn-quicknext"
            tabindex="0" />
        <li
            v-if="pageCount > 1"
            :class="{ active: currentPage === pageCount }"
            class="number"
            tabindex="0">
            {{ pageCount }}
        </li>
    </ul>
</template>

<script type="text/babel">
export default {
    name: 'app-pager',
    props: {
        currentPage: Number,
        pageCount: Number
    },
    data() {
        return {
            current: null,
            showPrevMore: false,
            showNextMore: false,
            quicknextIconClass: 'app-icon-more',
            quickprevIconClass: 'app-icon-more'
        }
    },
    computed: {
        pagers() {
            const pagerCount = 7
            const currentPage = Number(this.currentPage)
            const pageCount = Number(this.pageCount)
            let showPrevMore = false
            let showNextMore = false
            if (pageCount > pagerCount) {
                if (currentPage > pagerCount - 3) {
                    showPrevMore = true
                }
                if (currentPage < pageCount - 3) {
                    showNextMore = true
                }
            }
            const array = []
            if (showPrevMore && !showNextMore) {
                const startPage = pageCount - (pagerCount - 2)
                for (let i = startPage; i < pageCount; i++) {
                    array.push(i)
                }
            }
            else if (!showPrevMore && showNextMore) {
                for (let i = 2; i < pagerCount; i++) {
                    array.push(i)
                }
            }
            else if (showPrevMore && showNextMore) {
                const offset = Math.floor(pagerCount / 2) - 1
                for (
                    let i = currentPage - offset;
                    i <= currentPage + offset;
                    i++
                ) {
                    array.push(i)
                }
            }
            else {
                for (let i = 2; i < pageCount; i++) {
                    array.push(i)
                }
            }
            // eslint-disable-next-line
            this.showPrevMore = showPrevMore
            // eslint-disable-next-line
            this.showNextMore = showNextMore
            return array
        }
    },
    methods: {
        onPagerClick(event) {
            const target = event.target
            if (target.tagName === 'UL') {
                return
            }
            let newPage = Number(event.target.textContent)
            const pageCount = this.pageCount
            const currentPage = this.currentPage
            if (target.className.indexOf('more') !== -1) {
                if (target.className.indexOf('quickprev') !== -1) {
                    newPage = currentPage - 5
                }
                else if (target.className.indexOf('quicknext') !== -1) {
                    newPage = currentPage + 5
                }
            }
            /* istanbul ignore if */
            if (!isNaN(newPage)) {
                if (newPage < 1) {
                    newPage = 1
                }
                if (newPage > pageCount) {
                    newPage = pageCount
                }
            }
            if (newPage !== currentPage) {
                this.$emit('change', newPage)
            }
        }
    },
    watch: {
        showPrevMore(val) {
            if (!val) this.quickprevIconClass = 'app-icon-more'
        },
        showNextMore(val) {
            if (!val) this.quicknextIconClass = 'app-icon-more'
        }
    }
}
</script>

<style lang="stylus">
@import '../../../stylus/variables'

.app-pager
    user-select: none
    list-style: none
    vertical-align: top
    display: inline-block
    margin: 0
    padding: 0
    li
        vertical-align: top
        display: inline-block
        background: #FFF
        min-width: 35.5px
        height: 28px
        line-height: 28px
        text-align: center
        font-size: 14px
        border-radius: 8px
        margin: 0px
        padding: 0px
        color: $text-dark-grey
        min-width: 30px
        cursor: pointer

        &:hover
            background: $light-grey
            text-decoration: underline
            color: $text-dark-grey

        &.active, &:focus
            background: $dark-blue
            color: $white
            margin: 0px 2px
            padding: 0px !important
            cursor: default
            & + li 
                border-left: 0
    .more::before
        line-height: 30px
        content: '\2026'
    li.btn-quicknext,
    li.btn-quickprev 
        line-height 28px
        color #303133
    li.btn-quicknext.disabled,
    li.btn-quickprev.disabled 
        color #C0C4CC
</style>
